var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(!_vm.switchFlg)?_c('editFollow',{attrs:{"selectlists":_vm.selectlists,"footerdata":_vm.footerdata}}):_vm._e(),(_vm.switchFlg)?_c('createFollow',{on:{"swicth":_vm.swicth}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }